<div class="row no-gutters">
  <div>
    <span class="toast-message">{{ message }}</span>
  </div>
</div>
